'use strict';

function MaskFactory(bodyClass) {
    /* Creates the mask */
    function _createMask() {
        var mask = document.getElementById('ppICMask');
        var actualWidth = document.documentElement ? document.documentElement.clientWidth : window.innerWidth;
        var windowWidth, windowHeight, scrollWidth, scrollHeight, width, height;

        if (window.innerHeight && window.scrollMaxY) {
            scrollWidth = actualWidth + window.scrollMaxX;
            scrollHeight = window.innerHeight + window.scrollMaxY;
        } else if (document.body.scrollHeight > document.body.offsetHeight) {
            scrollWidth = document.body.scrollWidth;
            scrollHeight = document.body.scrollHeight;
        } else {
            scrollWidth = document.body.offsetWidth;
            scrollHeight = document.body.offsetHeight;
        }

        if (window.innerHeight) {
            windowWidth = actualWidth;
            windowHeight = window.innerHeight;
        } else if (document.documentElement && document.documentElement.clientHeight) {
            windowWidth = document.documentElement.clientWidth;
            windowHeight = document.documentElement.clientHeight;
        } else if (document.body) {
            windowWidth = document.body.clientWidth;
            windowHeight = document.body.clientHeight;
        }

        width = windowWidth > scrollWidth ? windowWidth : scrollWidth;
        height = windowHeight > scrollHeight ? windowHeight : scrollHeight;

        if (mask) {
            mask.style.width = width + 'px';
            mask.style.height = height + 'px';
        }

        if (bodyClass && document.body.className.indexOf(bodyClass) === -1) {
            document.body.className += ' ' + bodyClass;
        }
    }

    function _hideMask() {
        var mask = document.getElementById('ppICMask'),
            frame = mask && mask.parentNode;
        if (frame) {
            frame.parentNode.removeChild(frame);

        }
    }

    return {
        create: _createMask,
        hide: _hideMask
    };
}

module.exports = MaskFactory;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/mask.js
 ** module id = 21
 ** module chunks = 0
 **/